// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";

import OverlayContext from './context/OverlayContext';
import Mazemap from '@itpi/mazemap';
import '@itpi/mazemap/mazemap.min.css';

interface ISearch {
    onFind: Function;
}

const Search: React.FC<ISearch> = ({
  onFind,
}) => {
    const {id, mapReady} = useContext(OverlayContext);

    useEffect(() => {
        if(mapReady) {
            var mySearch = new Mazemap.Search.SearchController({
                campusid: 341,
        
                rows: 10,
        
                withpois: true,
                withbuilding: false,
                withtype: false,
                withcampus: false,
        
                resultsFormat: "geojson",
            });
        
            var mySearchInput = new Mazemap.Search.SearchInput({
                container: document.getElementById(`search-input-container-${id}`),
                input: document.getElementById(`searchInput-${id}`),
                suggestions: document.getElementById(`suggestions-${id}`),
                searchController: mySearch,
            });
        
            mySearchInput.on("itemclick", function (e) {
                onFind(e.item)
            });
        }
    }, [mapReady]);
    
  return (
    <div id={`search-input-container-${id}`} className='search-control-default' style={{position: "absolute", top: 10, left: 10, width: "calc(100% - 20px)", zIndex: 10}}>
        <input tabIndex="0" id={`searchInput-${id}`} className="search-input" autoComplete="off" type="text" name='search' placeholder='Search'/>

        <div id={`suggestions-${id}`} className="search-suggestions default"></div>
    </div>
  );
};

export default Search;
